var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.studiengang && _vm.sprache)?_c('div',[(_vm.sprache === 'de')?_c('span',[_vm._v(" "+_vm._s(_vm.studiengang.labelDe)+" ("+_vm._s(_vm.studiengang.kuerzel)+") ")]):_c('span',[_vm._v(" "+_vm._s(_vm.studiengang.labelEn)+" ("+_vm._s(_vm.studiengang.kuerzel)+") ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }